<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-06-17 11:27:23
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-06-17 14:07:00
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/mini-h5/components/countryPop.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <van-popup v-model="show" round position="bottom">
    <div class="bg-fff p-relative pb-10 border-box " style="height: 70vh;background: #fff;">
      <div class="d-flex a-center px-12 border-box j-sb" style="height: 76px">
        <div class="cor-262626 fz-17 fw-6">{{$t('lang.t233')}}</div>
        <div class="iconfont cor-8C8C8C fz-16 fw-7" @click="close">{{ `\ue72d` }}</div>
      </div>
      <div class="searchBox">
        <div class="iconfont searchIcon">{{ `\ue6c8` }}</div>
        <input :type="type" class="search" v-model="inputVal" :placeholder="$t('lang.t333')" placeholder-class="cor-BFBFBF" @input="valueChange" />
      </div>
      <div style="overflow-y:scroll;" :style="{ height: `calc(70vh - ${overHeight}px)` }">
        <div v-for="(item, index) in countryList" :key="index">
          <div class="d-flex a-center bg-white j-sb px-12" style="height: 40px" @click="handleConfirm(index)">
            <div class="cor-262626 fz-16">{{ item.country }}</div>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'multipleLangPop',
  props: {
    countryList: {
      type: Array,
      default: [],
    },
    language: {
      type: String,
      default: 'CN',
    },
  },
  data() {
    return {
      show: false,
      overHeight: 56,
      type: 'text',
      inputVal: '',
      translationTextList: ['请选择地区', '请输入'],
      placeholder: '',
    }
  },
  mounted() {
    // this.translationTextList = countryLanArr[this.language];
  },
  methods: {
    // 关闭
    close() {
      this.$emit('valueChange', '')
      this.show = false
      this.inputVal = ''
    },
    open() {
      this.show = true
    },
    valueChange(e) {
      let detail = this.inputVal || ''
      this.$emit('valueChange', detail)
    },
    handleConfirm(index) {
      this.$emit('handleConfirm', this.countryList[index])
      this.show = false
    },
  },
}
</script>
<style scoped lang="less">
.fz-55 {
  font-size: 55rpx;
}
.tipsBg {
  background: rgba(255, 156, 0, 0.1);
}
.searchBox {
  width: 351px;
  height: 40px;
  display: flex;
  margin: 0 auto;
  background: #f5f5f5;
  border-radius: 20px;
  align-items: center;
  padding: 0 13px;
  .searchIcon {
    font-size: 23px;
    margin-right: 2px;
    color: #bfbfbf;
  }
  .search {
    height: 20px;
    flex: 1;
    font-size: 16px;
    background: none;
  }
}
</style>
